var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{key:_vm.imageKey,staticClass:"markdown-image",class:{ 'image-layout-single': _vm.imageLayout === 'single' },attrs:{"src":_vm.url,"alt":_vm.alt,"loading":"eager","decoding":"async"}})
}
var staticRenderFns = []

export { render, staticRenderFns }